<template>
  <div class="contact-us-page">
    <div class="container pt-5 pb-5">
      <div class="row">
        <div class="col"></div>
        <div class="col-sm-10 col-md-6 col-xl-6">
          <div class="alert alert-info" v-if="resultMessage != ''">
            {{resultMessage}}
          </div>
          <h4 class="mb-0">Get in Touch</h4>
          <p class="text-muted">Please fill out the quick form and we will get back to you soon.</p>
          <form name="contact-form" method="post" @submit.prevent="handleSubmit">
            <div class="mb-3">
              <label for="name">Name <span class="text-muted">(Optional)</span></label>
              <input type="text" class="form-control" name="name" @input="ev => form.name = ev.target.value" placeholder="Jack Carver" :value="form.name">
            </div>
            <div class="mb-3">
              <label for="email">Email</label>
              <input type="email" class="form-control" name="email" @input="ev => form.email = ev.target.value" placeholder="you@example.com" required :value="form.email">
            </div>
            <div class="mb-3">
              <label for="message">Message</label>
              <textarea class="form-control" name="message" @input="ev => form.message = ev.target.value" placeholder="Say Hi" required="" cols="10" rows="5" :value="form.message"/>
            </div>
            <div class="row">
              <div class="col">
                <button class="btn btn-primary btn-block" type="submit">Send</button>
              </div>
              <div class="col d-flex align-items-center justify-content-end">
                <p class="text-muted mb-0">or Email us at <a href="mailto:hello@codehit.net">hello@codehit.net</a></p>
              </div>
            </div>
          </form>
        </div>
        <div class="col"></div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'Contact',
  components: {
    Footer
  },
  data() {
    return {
      resultMessage: '',
      form: {
        name: "",
        email: "",
        message: ""
      },
      action: {
        formSpree: 'https://formspree.io/xgenqyob',
        aws: 'https://52uan0u78c.execute-api.ap-southeast-1.amazonaws.com/Production/contact-us',
      }
    }
  },
  methods: {
    encode(data) {
      return Object.keys(data)
        .map(
          key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
        )
        .join("&")
    },
    clearAlerts () {
      setTimeout(function () {
        this.resultMessage = ''
      }, 2000)
    },
    submitForm () {
      const self = this
      fetch(self.action.formSpree, {
        method: "POST",
        dataType: "json",
        crossDomain: "true",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify(this.form)
      })
        .then(() => {
          self.form = {
            name: '',
            email: '',
            message: ''
          }
          self.resultMessage = "Thank you for reaching us. We will get back to you soon."
          self.clearAlerts()
        })
        .catch(() => {
          self.resultMessage = "Sorry. We are having technical problem at the moment."
          self.clearAlerts()
        })
    },
    handleSubmit() {
      if (this.form.email.trim() != '' && this.form.message.trim() != '') {
        this.submitForm()
      }
    }
  }
}
</script>
